module.exports = require("@swa-ui/core/src/Badge/Badge.module.scss");